import PropTypes from 'prop-types';
import React from 'react';
import content from '../../locales/en/content.json';
import {
  getProfilePrefillPermanentAndTotal,
  getProfilePrefillRating,
  showSponsorDisabilityRating,
  showSponsorNotPermanentAndTotalWarning,
} from '../../utils/helpers';
import PrefillCard from '../FormFields/PrefillCard';
import ExitApplicationLink from './ExitApplicationLink';

const CARD_TITLE = content['sponsor--prefill-disability-card-title'];

const SponsorDisabilityPrefillInfo = ({ formData = {} }) => {
  const showWarning = showSponsorNotPermanentAndTotalWarning(formData);
  const showRating = showSponsorDisabilityRating(formData);
  const isPermanentAndTotal = getProfilePrefillPermanentAndTotal(formData);

  if (!showWarning && !showRating) return null;

  return (
    <>
      {showWarning && (
        <va-alert status="warning" data-testid="sponsor-disability-warning">
          <p className="vads-u-margin-top--0">
            {content['sponsor--prefill-disability-alert-text']}
          </p>
          <ExitApplicationLink location="sponsor-disability" />
        </va-alert>
      )}
      {showRating && (
        <PrefillCard title={CARD_TITLE} testId="sponsor-disability-card">
          <p className="vads-u-margin--0 dd-privacy-hidden">
            {content['sponsor--prefill-disability-card-intro']}{' '}
            <strong>
              {content['sponsor--prefill-disability-card-rating']}{' '}
              {getProfilePrefillRating(formData)}%
            </strong>
            .{' '}
            {isPermanentAndTotal === true &&
              content['sponsor--prefill-disability-card-eligible']}
          </p>
        </PrefillCard>
      )}
    </>
  );
};

SponsorDisabilityPrefillInfo.propTypes = {
  formData: PropTypes.object,
};

export default SponsorDisabilityPrefillInfo;
